import store from '@/store';

function enabled(feature) {
    if (!feature) {
        return true;
    }

    return store.state.UiStore.features[feature];
}

export const feature = { enabled };

const XlinxFeature = {
    install(app) {
        // eslint-disable-next-line no-param-reassign
        app.config.globalProperties.$feature = feature;
    },
};

export default XlinxFeature;
